import { html } from 'omni-ui';
import { Om2FormFieldBase, SHARED_FIELD } from './common/base.js';

/**
 * Render file input. If this gets used more heavily we may need to tweak this.
 * This is used in the construct app.
 */
export class Om2FormFieldFile extends Om2FormFieldBase {
  static metadata = {
    config: {
      label: 'File Input',
      fields: {
        id: SHARED_FIELD,
        title: SHARED_FIELD,
        accept: {
          title: 'Accept',
          tooltip:
            'The file types the file input should accept. This string is a comma-separated list of unique file type specifiers, e.g. .doc,.docx,.xml',
          type: 'string',
        },
        tooltip: SHARED_FIELD,
        required: SHARED_FIELD,
        disabled: SHARED_FIELD,
        readonly: {
          title: 'Read Only',
          type: 'boolean',
          tooltip:
            "Rendered as disabled since the image component can't be readonly",
        },
      },
      // Indicate that we shouldn't show this option by default
      // Because file input components can't be part of a normal JSON fetch payload,
      // exclude it unless expicitly requested to avoid issues.
      exclude: true,
    },
  };

  render() {
    const { schema } = this;
    return html`
      <div class="is-flex is-align-items-center">
        <button
          type="button"
          class="button is-outlined is-medium"
          @click=${e => e.target.nextElementSibling.click()}
        >
          Browse
        </button>
        <input
          type="file"
          name="${this.key}"
          style="z-index: -1; width: 1px"
          accept="${schema.accept}"
          tabindex="-1"
          @input=${e => {
            e.stopPropagation();
            this.dispatchNewEvent('input', {
              detail: {
                name: this.key,
                value: e.target?.files?.[0] ?? undefined,
              },
            });
          }}
          ?required=${schema.required}
          ?disabled=${schema.disabled ||
          schema.readonly ||
          this.context?.readonly ||
          this._isHidden()}
        />
        <div class="ml-3">${this.data?.name ?? 'No file selected'}</div>
      </div>
    `;
  }
}

Om2FormFieldFile.register('file');
